import request, { merchantApi } from '@/config/axios'

export type HotelOnboardingStatus =
  'DRAFT' | 'PENDING' | 'APPROVED' | 'REJECTED' | 'PROVISIONING' | 'ACTIVE' | 'FAILED' | 'CANCELED'

export interface HotelQualificationMaterial {
  name: string
  url: string
}

export interface HotelOnboardingApplication {
  id: string | number
  applicantMemberId?: string | number
  merchantId?: string | number
  applicantAccountId?: string | number
  companyName?: string
  licenseNo?: string
  licenseUrl?: string
  legalPerson?: string
  contactEmail?: string
  hotelName: string
  propertyType: number
  address: string
  contactName: string
  contactPhone: string
  qualificationJson: string
  status: HotelOnboardingStatus
  shopId?: string | number
  operationMode?: string
  commissionRate?: number
  settleCycle?: string
  provisionAttempts?: number
  lastProvisionError?: string
  submitTime?: string
  auditTime?: string
  auditUserId?: string | number
  rejectReason?: string
  cancelTime?: string
  createTime?: string
}

export interface HotelContract {
  id: string | number
  applicationId: string | number
  merchantId: string | number
  shopId?: string | number
  contractNo: string
  contractFileUrl: string
  operationMode: string
  commissionRate: number
  settleCycle: string
  effectiveDate: string
  expiryDate: string
  depositAmount: number
  autoRenew: boolean
  version: number
  status: string
}

export interface HotelOnboardingAuditLog {
  id: string | number
  applicationId: string | number
  action: string
  fromStatus?: string
  toStatus: string
  opinion?: string
  operatorType: string
  operatorId?: string | number
  createTime?: string
}

export interface HotelOnboardingSaveReq {
  id?: string | number
  hotelName: string
  propertyType: number
  address: string
  contactName: string
  contactPhone: string
  qualificationJson: string
}

export interface HotelOnboardingAuditReq {
  applicationId: string | number
  approved: boolean
  opinion: string
  contractNo?: string
  contractFileUrl?: string
  operationMode?: string
  commissionRate?: number
  settleCycle?: string
  effectiveDate?: string
  expiryDate?: string
  depositAmount?: number
  autoRenew?: boolean
}

const MERCHANT_BASE = '/merchant-api/hotel/onboarding'
const ADMIN_BASE = '/hotel/platform/onboarding'

export const getMerchantOnboardingPage = (params: any) =>
  merchantApi.get({ url: `${MERCHANT_BASE}/page`, params })

export const createMerchantOnboarding = (data: HotelOnboardingSaveReq) =>
  merchantApi.post<string | number>({ url: `${MERCHANT_BASE}/create`, data })

export const updateMerchantOnboarding = (data: HotelOnboardingSaveReq) =>
  merchantApi.put<boolean>({ url: `${MERCHANT_BASE}/update`, data })

export const submitMerchantOnboarding = (id: string | number) =>
  merchantApi.post<boolean>({ url: `${MERCHANT_BASE}/submit`, params: { id } })

export const getAdminOnboardingPage = (params: any) =>
  request.get({ url: `${ADMIN_BASE}/page`, params })

export const getAdminOnboarding = (id: string | number) =>
  request.get<HotelOnboardingApplication>({ url: `${ADMIN_BASE}/get`, params: { id } })

export const getAdminOnboardingAuditLogs = (applicationId: string | number) =>
  request.get<HotelOnboardingAuditLog[]>({
    url: `${ADMIN_BASE}/audit-logs`,
    params: { applicationId }
  })

export const getAdminOnboardingContract = (applicationId: string | number) =>
  request.get<HotelContract | null>({
    url: `${ADMIN_BASE}/contract`,
    params: { applicationId }
  })

export const auditAdminOnboarding = (data: HotelOnboardingAuditReq) =>
  request.post<boolean>({ url: `${ADMIN_BASE}/audit`, data })

export const retryAdminOnboardingProvision = (applicationId: string | number) =>
  request.post<boolean>({
    url: `${ADMIN_BASE}/retry-provision`,
    params: { applicationId }
  })
